import {
  ProductSearchResult,
  TargetingLocationVariant,
} from '../menu-service.types';

export type FixtureProduct = ProductSearchResult & {
  locations: TargetingLocationVariant[];
};

export const targetingItemResults: FixtureProduct[] = [
  {
    incentivioId: 'inc-item-001',
    externalId: 'ext-id-item-001',
    extTargetingId: 'ext-item-001',
    title: 'Cheeseburger',
    productType: 'ITEM',
    locationVariationCount: 3,
    priceVariationCount: 2,
    locations: [
      {
        productTitle: 'Cheeseburger',
        incentivioId: 'inc-item-001',
        externalId: 'ext-id-item-001',
        locationName: 'Downtown Store',
        locationId: 'loc-001',
        price: 9990,
        status: 'ACTIVE',
        itemType: 'MAIN',
        productId: 'prod-001',
      },
      {
        productTitle: 'Classic Cheeseburger',
        incentivioId: 'inc-item-001',
        externalId: 'ext-id-item-001',
        locationName: 'Uptown Store',
        locationId: 'loc-002',
        price: 11990,
        status: 'ACTIVE',
        itemType: 'MAIN',
        productId: 'prod-002',
      },
      {
        productTitle: 'Cheeseburger',
        incentivioId: 'inc-item-001',
        externalId: 'ext-id-item-001',
        locationName: 'Airport Store',
        locationId: 'loc-003',
        price: 11990,
        status: 'INACTIVE',
        itemType: 'MAIN',
        productId: 'prod-003',
      },
    ],
  },
  {
    incentivioId: 'inc-item-002',
    externalId: 'ext-id-item-002',
    extTargetingId: 'ext-item-002',
    title: 'French Fries',
    productType: 'ITEM',
    locationVariationCount: 2,
    priceVariationCount: 1,
    locations: [
      {
        productTitle: 'French Fries',
        incentivioId: 'inc-item-002',
        externalId: 'ext-id-item-002',
        locationName: 'Downtown Store',
        locationId: 'loc-001',
        price: 4990,
        status: 'ACTIVE',
        itemType: 'MAIN',
        productId: 'prod-004',
      },
      {
        productTitle: 'French Fries',
        incentivioId: 'inc-item-002',
        externalId: 'ext-id-item-002',
        locationName: 'Uptown Store',
        locationId: 'loc-002',
        price: 4990,
        status: 'ACTIVE',
        itemType: 'MAIN',
        productId: 'prod-005',
      },
    ],
  },
  {
    incentivioId: 'inc-item-003',
    externalId: 'ext-id-item-003',
    extTargetingId: 'ext-item-003',
    title: 'Extra Cheese',
    productType: 'ITEM',
    locationVariationCount: 1,
    priceVariationCount: 1,
    locations: [
      {
        productTitle: 'Extra Cheese',
        incentivioId: 'inc-item-003',
        externalId: 'ext-id-item-003',
        locationName: 'Downtown Store',
        locationId: 'loc-001',
        price: 1500,
        status: 'ACTIVE',
        itemType: 'MODIFIER',
        productId: 'prod-006',
      },
    ],
  },
  {
    incentivioId: 'inc-item-004',
    externalId: 'ext-id-item-004',
    extTargetingId: 'ext-item-004',
    title: 'Bacon Burger',
    productType: 'ITEM',
    locationVariationCount: 2,
    priceVariationCount: 2,
    locations: [
      {
        productTitle: 'Bacon Burger',
        incentivioId: 'inc-item-004',
        externalId: 'ext-id-item-004',
        locationName: 'Downtown Store',
        locationId: 'loc-001',
        price: 12990,
        status: 'ACTIVE',
        itemType: 'MAIN',
        productId: 'prod-007',
      },
    ],
  },
  {
    incentivioId: 'inc-item-005',
    externalId: 'ext-id-item-005',
    extTargetingId: 'ext-item-005',
    title: 'Onion Rings',
    productType: 'ITEM',
    locationVariationCount: 1,
    priceVariationCount: 1,
    locations: [
      {
        productTitle: 'Onion Rings',
        incentivioId: 'inc-item-005',
        externalId: 'ext-id-item-005',
        locationName: 'Downtown Store',
        locationId: 'loc-001',
        price: 5490,
        status: 'ACTIVE',
        itemType: 'MAIN',
        productId: 'prod-008',
      },
    ],
  },
  {
    incentivioId: 'inc-item-006',
    externalId: 'ext-id-item-006',
    extTargetingId: 'ext-item-006',
    title: 'Chicken Sandwich',
    productType: 'ITEM',
    locationVariationCount: 2,
    priceVariationCount: 1,
    locations: [
      {
        productTitle: 'Chicken Sandwich',
        incentivioId: 'inc-item-006',
        externalId: 'ext-id-item-006',
        locationName: 'Downtown Store',
        locationId: 'loc-001',
        price: 10990,
        status: 'ACTIVE',
        itemType: 'MAIN',
        productId: 'prod-009',
      },
    ],
  },
  {
    incentivioId: 'inc-item-007',
    externalId: 'ext-id-item-007',
    extTargetingId: 'ext-item-007',
    title: 'Milkshake',
    productType: 'ITEM',
    locationVariationCount: 1,
    priceVariationCount: 3,
    locations: [
      {
        productTitle: 'Milkshake',
        incentivioId: 'inc-item-007',
        externalId: 'ext-id-item-007',
        locationName: 'Downtown Store',
        locationId: 'loc-001',
        price: 6990,
        status: 'ACTIVE',
        itemType: 'MAIN',
        productId: 'prod-010',
      },
    ],
  },
  {
    incentivioId: 'inc-item-008',
    externalId: 'ext-id-item-008',
    extTargetingId: 'ext-item-008',
    title: 'Caesar Salad',
    productType: 'ITEM',
    locationVariationCount: 2,
    priceVariationCount: 1,
    locations: [
      {
        productTitle: 'Caesar Salad',
        incentivioId: 'inc-item-008',
        externalId: 'ext-id-item-008',
        locationName: 'Downtown Store',
        locationId: 'loc-001',
        price: 8990,
        status: 'ACTIVE',
        itemType: 'MAIN',
        productId: 'prod-011',
      },
    ],
  },
  {
    incentivioId: 'inc-item-009',
    externalId: 'ext-id-item-009',
    extTargetingId: 'ext-item-009',
    title: 'Hot Dog',
    productType: 'ITEM',
    locationVariationCount: 1,
    priceVariationCount: 1,
    locations: [
      {
        productTitle: 'Hot Dog',
        incentivioId: 'inc-item-009',
        externalId: 'ext-id-item-009',
        locationName: 'Downtown Store',
        locationId: 'loc-001',
        price: 5990,
        status: 'ACTIVE',
        itemType: 'MAIN',
        productId: 'prod-012',
      },
    ],
  },
  {
    incentivioId: 'inc-item-010',
    externalId: 'ext-id-item-010',
    extTargetingId: 'ext-item-010',
    title: 'Fish Tacos',
    productType: 'ITEM',
    locationVariationCount: 2,
    priceVariationCount: 2,
    locations: [
      {
        productTitle: 'Fish Tacos',
        incentivioId: 'inc-item-010',
        externalId: 'ext-id-item-010',
        locationName: 'Downtown Store',
        locationId: 'loc-001',
        price: 11490,
        status: 'ACTIVE',
        itemType: 'MAIN',
        productId: 'prod-013',
      },
    ],
  },
  {
    incentivioId: 'inc-item-011',
    externalId: 'ext-id-item-011',
    extTargetingId: 'ext-item-011',
    title: 'BBQ Ribs',
    productType: 'ITEM',
    locationVariationCount: 1,
    priceVariationCount: 1,
    locations: [
      {
        productTitle: 'BBQ Ribs',
        incentivioId: 'inc-item-011',
        externalId: 'ext-id-item-011',
        locationName: 'Downtown Store',
        locationId: 'loc-001',
        price: 16990,
        status: 'ACTIVE',
        itemType: 'MAIN',
        productId: 'prod-014',
      },
    ],
  },
  {
    incentivioId: 'inc-item-012',
    externalId: 'ext-id-item-012',
    extTargetingId: 'ext-item-012',
    title: 'Veggie Wrap',
    productType: 'ITEM',
    locationVariationCount: 2,
    priceVariationCount: 1,
    locations: [
      {
        productTitle: 'Veggie Wrap',
        incentivioId: 'inc-item-012',
        externalId: 'ext-id-item-012',
        locationName: 'Downtown Store',
        locationId: 'loc-001',
        price: 8490,
        status: 'ACTIVE',
        itemType: 'MAIN',
        productId: 'prod-015',
      },
    ],
  },
  {
    incentivioId: 'inc-item-013',
    externalId: 'ext-id-item-013',
    extTargetingId: 'ext-item-013',
    title: 'Mozzarella Sticks',
    productType: 'ITEM',
    locationVariationCount: 1,
    priceVariationCount: 1,
    locations: [
      {
        productTitle: 'Mozzarella Sticks',
        incentivioId: 'inc-item-013',
        externalId: 'ext-id-item-013',
        locationName: 'Downtown Store',
        locationId: 'loc-001',
        price: 7490,
        status: 'ACTIVE',
        itemType: 'MODIFIER',
        productId: 'prod-016',
      },
    ],
  },
  {
    incentivioId: 'inc-item-014',
    externalId: 'ext-id-item-014',
    extTargetingId: 'ext-item-014',
    title: 'Grilled Chicken',
    productType: 'ITEM',
    locationVariationCount: 2,
    priceVariationCount: 2,
    locations: [
      {
        productTitle: 'Grilled Chicken',
        incentivioId: 'inc-item-014',
        externalId: 'ext-id-item-014',
        locationName: 'Downtown Store',
        locationId: 'loc-001',
        price: 13990,
        status: 'ACTIVE',
        itemType: 'MAIN',
        productId: 'prod-017',
      },
    ],
  },
  {
    incentivioId: 'inc-item-015',
    externalId: 'ext-id-item-015',
    extTargetingId: 'ext-item-015',
    title: 'Loaded Nachos',
    productType: 'ITEM',
    locationVariationCount: 1,
    priceVariationCount: 1,
    locations: [
      {
        productTitle: 'Loaded Nachos',
        incentivioId: 'inc-item-015',
        externalId: 'ext-id-item-015',
        locationName: 'Downtown Store',
        locationId: 'loc-001',
        price: 9490,
        status: 'ACTIVE',
        itemType: 'MAIN',
        productId: 'prod-018',
      },
    ],
  },
];

export const targetingItems = {
  results: targetingItemResults,
};
